import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification-destination-email',
  templateUrl: './help-add-notification-destination-email.component.html',
  styleUrls: ['./help-add-notification-destination-email.component.scss']
})
export class HelpAddNotificationDestinationEmailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
